import React, { Component } from 'react';
import classnames from 'classnames';
import { Link, withRouter } from "react-router-dom";
import styles from './sideMenu.module.scss';
import API from '../utils/API';
import { strings } from '../utils/translations';
import { ReactComponent as HHLogo } from '../../img/homyhub_logo_houses.svg';
import FeaturesIcon from '../../img/icons/FeaturesIcon';
import GaragesIcon from '../../img/icons/GaragesIcon';
import { ReactComponent as LogoutIcon } from '../../img/icons/logout-icon.svg';
import ExtraRemotesIcon from '../../img/icons/ExtraRemotesIcon'
import packageJson from '../../../package.json'
import { Modal, Dropdown, Menu, Input, notification, Tooltip } from 'antd'
import Colors from '../../css/vars.scss'
import Loader from '../../components/Loader'
import { DarkModeToggle } from '@anatoliygatt/dark-mode-toggle'
import { DarkModeContext } from '../../providers/DarkModeContext'
import EllipsisIcon from '../../img/icons/ellipsis.svg'

class SideMenu extends Component
{
	static contextType = DarkModeContext
	
	constructor(props)
	{
		super(props)

		this.state =
		{
			user: null,
            numUnseenFeatures: 0,
            activeItem: 1,
			
			isSendingDelete: false,
			deleteUserCodeSent: false,
			isVerifyingDelete: false
		}
	}
	componentDidMount()
	{
		this.setState({ activeItem: this.getActiveItemFromPath() })
		this.getCurrentUser()
		
		this.props.history.listen((data) =>
		{
			let pathname = data.pathname
			this.setState({ activeItem: this.getActiveItemFromPath(pathname) })
		})
	}
	
	render()
	{
		const { isAuto, darkMode, setTheme, osDark, theme } = this.context
        let activeOptionColor = (darkMode ? Colors.purplePrimaryLighter : Colors.purplePrimary)
        let activeBackground = classnames([styles.featureOption, styles.active]);

		return (
            <div className={classnames([styles.sideMenu, this.props.className ? styles[this.props.className] : null])}>
                <Link to="/garages">
                    <HHLogo className={styles.logo} />
                </Link>
				
                <div className={styles.featuresContainer}>
					<GaragesIcon
						size={26}
						color={(this.state.activeItem === 1) ? activeOptionColor : (darkMode ? Colors.systemGrayDark : Colors.systemGray)}
						className={(this.state.activeItem === 1) ? activeBackground : styles.featureOption}
						textClassName={styles.featureOptionText}
					/>
					<ExtraRemotesIcon
						size={18}
						height={'33px'}
						color={(this.state.activeItem === 2) ? activeOptionColor : (darkMode ? Colors.systemGrayDark : Colors.systemGray)}
						className={(this.state.activeItem === 2) ? activeBackground : styles.featureOption}
						textClassName={styles.featureOptionText}
					/>
                </div>
				
				<div>
					<div>
						<div className={styles.featureOption} onClick={this.logout.bind(this)}>
							<LogoutIcon className={styles.logoutIcon} />
							<div className={styles.featureOptionText}>{ strings('sideMenuLogOut') }</div>
						</div>
						
						<div className={styles.separator} />
						
						{
							this.state.user != null &&
							<div className={styles.email}>{ this.state.user.email }</div>
						}
						
						{
							this.state.user != null &&
							<Dropdown
								trigger={['click']}
								overlay={<Menu>
											<Menu.Item
												key="deleteAccount"
												style={{ color: Colors.systemRed }}
												onClick={this.onPressDeleteAccount.bind(this)}
											>
												{strings('deleteAccount')}
											</Menu.Item>
										 </Menu>}
							>
								<div className={styles.moreOptions}>
									<img
										src={EllipsisIcon}
										alt="Account options"
										className={styles.moreOptionsIcon}
									/>
								</div>
							</Dropdown>
						}
						
						<div className={styles.separator} />
					</div>
					
					<Tooltip
						title={`${strings('theme')}: ${isAuto ? 'auto' : (darkMode ? strings('dark') : strings('light'))}`}
						placement="right"
					>
						<div className={classnames(styles.themeSwitch,
													isAuto ? styles.isAuto : null,
													styles[theme])}
						>
							<img src={require('../../img/icons/moon.svg').default} />
							<DarkModeToggle
								mode={darkMode ? 'dark' : 'light'}
								size="sm"
								inactiveTrackColor={Colors.systemGray2Dark}
								inactiveTrackColorOnHover={Colors.systemGrayDark}
								inactiveTrackColorOnActive={Colors.systemGray3Dark}
								activeTrackColor={Colors.systemGray2}
								activeTrackColorOnHover={Colors.systemGray}
								activeTrackColorOnActive={Colors.systemGray3}
								inactiveThumbColor={Colors.systemGray6Dark}
								activeThumbColor={Colors.systemGray5}
								onChange={(mode) =>
								{
									if (!isAuto && osDark == darkMode)
										setTheme('auto')
									else
										setTheme(mode)
								}}
							/>
							<img src={require('../../img/icons/sun.svg').default} />
						</div>
					</Tooltip>
					
					<div className={styles.appVersion}>
						v{ packageJson?.version }
					</div>
				</div>
				
				<Modal
					title={strings('deleteAccountTypeCodeTitle')}
					visible={this.state.deleteUserCodeSent}
					okText={strings('deleteAccountAlertButton')}
					cancelText={strings('cancel')}
					centered
					destroyOnClose
					onCancel={() => this.setState({ deleteUserCodeSent: false })}
				>
					{ strings('deleteAccountTypeCodeMessage') }
					
					{
						this.state.isVerifyingDelete ?
						<div className={styles.deleteAccountLoader}>
							<Loader
								spinner
								large
								fullWidth
								centerHorizontal
							/>
						</div>
						:
						<div className={styles.sixDigitInput}>
							<Input
								ref="input1"
								size="large"
								autocomplete="off"
								onChange={(e) => { if (e.target.value.length === 1) this.refs.input2.focus() }}
							/>
							<Input
								ref="input2"
								size="large"
								autocomplete="off"
								onChange={(e) => { if (e.target.value.length === 1) this.refs.input3.focus() }}
								onKeyDown={(e) => { if (e.keyCode === 8 && e.target.value.length === 0) this.refs.input1.focus() }}
							/>
							<Input
								ref="input3"
								size="large"
								autocomplete="off"
								onChange={(e) => { if (e.target.value.length === 1) this.refs.input4.focus() }}
								onKeyDown={(e) => { if (e.keyCode === 8 && e.target.value.length === 0) this.refs.input2.focus() }}
							/>
							<Input
								ref="input4"
								size="large"
								autocomplete="off"
								onChange={(e) => { if (e.target.value.length === 1) this.refs.input5.focus() }}
								onKeyDown={(e) => { if (e.keyCode === 8 && e.target.value.length === 0) this.refs.input3.focus() }}
							/>
							<Input
								ref="input5"
								size="large"
								autocomplete="off"
								onChange={(e) => { if (e.target.value.length === 1) this.refs.input6.focus() }}
								onKeyDown={(e) => { if (e.keyCode === 8 && e.target.value.length === 0) this.refs.input4.focus() }}
							/>
							<Input
								ref="input6"
								size="large"
								autocomplete="off"
								onChange={(e) => {
									let code = `${this.refs.input1.input.value}${this.refs.input2.input.value}${this.refs.input3.input.value}${this.refs.input4.input.value}${this.refs.input5.input.value}${this.refs.input6.input.value}`
									this.verifyDeleteUser(code)
								}}
								onKeyDown={(e) => { if (e.keyCode === 8 && e.target.value.length === 0) this.refs.input5.focus() }}
							/>
						</div>
					}
				</Modal>
            </div>
		);
	}

	getCurrentUser()
	{
		API.getInstance().getCurrentUser(true)
		.then(user =>
		{
			if (user != null)
				this.setState({ user: user });
		})
		.catch(error =>
		{
			console.log(error);
        });
    }
	getActiveItemFromPath(pathname)
	{
		let pathnameFinal = pathname ? pathname : this.props.history.location.pathname
		let activeItem = 1
		
		if (pathnameFinal === '/garages')
			activeItem = 1
		else if (pathnameFinal === '/extra-virtual-remotes')
			activeItem = 2
		else if (pathnameFinal === '/new-features')
			activeItem = 3
		else if (pathnameFinal === '/suggestion')
			activeItem = 4
		else if (pathnameFinal === '/promotion')
			activeItem = 5
		else if (pathnameFinal === '/profile')
			activeItem = 6
			
		return activeItem
	}
	
	onPressDeleteAccount()
	{
		Modal.confirm(
		{
			title: strings('userDeleteAlertTitle'),
			content: strings('deleteAccountWarning'),
			okText: strings('deleteAccountAlertButton'),
			cancelText: strings('cancel'),
			onOk: this.sendDeleteUser.bind(this),
			confirmLoading: this.state.isSendingDelete,
			centered: true,
			autoFocusButton: null,
			closable: true
		})
	}
	async sendDeleteUser()
	{
		this.setState({ isSendingDelete: true })
		
		try
		{
			await API.getInstance().deleteUser()
			this.setState({ deleteUserCodeSent: true }, () =>
			{
				setTimeout(() => this.refs['input1']?.focus(), 300)
			})
		}
		catch(err)
		{
			if (err?.response?.data?.error?.appError === 108)
            {
				Modal.warning(
				{
					title: strings('userDeleteHasHousesTitle'),
					content: strings('userDeleteHasHouses'),
					okButtonProps: { style: { display: 'none' } },
					cancelText: "OK",
					centered: true,
					autoFocusButton: null,
					closable: true
				})
            }
            else if (err?.response?.data?.error?.appError === 109)
            {
				Modal.warning(
				{
					title: strings('userDeleteHasPermissionsTitle'),
					content: strings('userDeleteHasPermissions'),
					okButtonProps: { style: { display: 'none' } },
					cancelText: "OK",
					centered: true,
					autoFocusButton: null,
					closable: true
				})
            }
		}
		finally
		{
			this.setState({ isSendingDelete: false })
		}
	}
	async verifyDeleteUser(code)
	{
		this.setState({ isVerifyingDelete: true })
		
		try
		{
			await API.getInstance().verifyDeleteUser(code)
			
			this.props.history.push('/')
	        API.getInstance().logout()
			
			notification.success(
            {
                message: strings('deleteAccountSuccess'),
                placement: 'top'
            })
		}
		catch(err)
		{
			console.log(err)
		}
		finally
		{
			this.setState({ isVerifyingDelete: false })
		}
	}

	logout()
	{
		this.props.history.push('/')
		
        API.getInstance().logout().then(response =>
		{
            console.log('logged out');
		})
		.catch(error =>
		{
			console.log(error);
		});
	}
}

export default withRouter(SideMenu)
